import React from "react";
import PageBanner from "../Components/PageBanner";
import ServicesOne from "../Components/Services/ServicesOne";
import ServicesCta from "../Components/Services/ServicesCta";
import BestFeatures from "../Components/Features/BestFeatures";
import Pricing from "../Components/Price/Pricing";
import FaqOne from "../Components/Faq/FaqOne";
import bannerBg from "../assets/img/Banners/ChairmansMessage.jpg";
import { Link } from "react-router-dom";
import coreImg2 from "../assets/img/home3/block2.png";
import coreImg1 from "../assets/img/home1/Naginbhai.jpg";

const Chairmain = () => {
  return (
    <>
      <PageBanner
        title="Chairman's Message  "
        bannerBg={bannerBg}
        currentPage="Chairman's Message"
      />
      {/* <ServicesOne/>
    <ServicesCta/>
    <BestFeatures/>
    <Pricing/>
    <FaqOne/> */}
      <section className="content-block-wrapper section-padding bg-circle fix">
        <div className="container">
          <div className="row  ">
            <div className="col-xl-3 col-lg-3 pe-xl-4 col-12">
              <div className="content-block-img justify-content-center">
                <img src={coreImg1} alt="" style={{
                  borderRadius:"50%"
                }} />
                
              </div>
            </div>
            <div className="col-xl-9 ps-xl-5 col-lg-9 col-12 mt-5 mt-lg-0">
              <div className="section-title-3">
              <h6 className="mt-3">NAGINKUMAR VALLBHDAS BHOJANI,</h6>
              <p>(Chairman – Shree Gita Group) </p>
                {/* <h6>Core Features</h6> */}
                {/* <h2>About Raw Cotton </h2> */}
                <p>
                It is a great pleasure to present SHREE GITA Group on the website which is primarily designed as a reference to provide you with most up to date information about our organization. 
                </p>
              
                <p>
                At SHREE GITA Group we are blessed with the success, growth and reputation since last five generations. This is all because of hard work and sincerity in business and trust on us from our clients, network of our business associates as well as our staff. Everyone associated with us is to be given the credit for their co-operation without which SHRE GITA would never have been at this stage. 
                </p>
               
                <p>
                With long experience and goodwill achieved, we look forward to more success and growth in the coming years. We continuously strive to offer good service to our clients all over the world. 
                </p>
                
                <p>
                Our team is dedicated to offer superior quality across all products and service parameters, value based offerings, follow a customer delight approach and maintaining the trust of patrons. 
                </p>
                 
                <p>
                I am sure with the patronage of our customers, banks, financial institutions and marketing associates, we shall be able to fulfill the dreams of millions and set new benchmarks which positively transform the quality of life and of the society at large. 
                </p>
                
                <p>
                I am always available to discuss any requirements and my team will always serve you.  
                </p>
                <p>
                Thanking You, 
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Chairmain;
